export const getListingIntentColor = (intent: string) => {
  return intent === 'rent'
    ? 'from-green-500 to-teal-500'
    : 'from-orange-500 to-red-500';
};